export default "__VITE_ASSET__66e27648__"